import { createFeatureSelector, createSelector } from '@ngrx/store'
import { IUser } from './auth.state'

export const authFeature = createFeatureSelector<{ user: IUser, loading: boolean }>('auth')
export const selectUser = createSelector(authFeature, (state: { user: IUser, loading: boolean }) => state.user)
